var map = {
	"./news_chili.png": "cb90",
	"./news_nonoshiri.png": "fb01",
	"./news_nonoshiri2.png": "80f1",
	"./news_nori.png": "dfeb",
	"./news_official.png": "cede",
	"./news_okazukan.png": "448c",
	"./news_sagashi.png": "6295",
	"./noimage.png": "58be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09e7";